/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiBadge } from '@elastic/eui'

import type { CCMClusterLicenseType } from '@modules/ccm-admin-lib/types'
import { FormattedMessage } from '@modules/i18n'

import type { FC } from 'react'

const CCMClusterLicenseTypeBadge: FC<{
  licenseType: CCMClusterLicenseType
}> = ({ licenseType }) => {
  if (licenseType === 'trial') {
    return (
      <EuiBadge color='hollow'>
        <FormattedMessage id='ccm.cluster-license-type-badge.trial' defaultMessage='Trial' />
      </EuiBadge>
    )
  }

  if (licenseType === 'enterprise') {
    return (
      <EuiBadge color='primary'>
        <FormattedMessage
          id='ccm.cluster-license-type-badge.enterprise'
          defaultMessage='Enterprise'
        />
      </EuiBadge>
    )
  }

  return null
}

export default CCMClusterLicenseTypeBadge
